import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiOutlineGithub,
  AiOutlineLinkedin,
  AiOutlineMail,
} from "react-icons/ai";
import { FaArrowUp } from "react-icons/fa";

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer-section">
      <Container>
        {/* Top Section */}
        <Row className="footer-top">
          <Col lg={8} md={6} className="footer-info">
            <h2 className="footer-name">Hassan Abrar</h2>
            <h3 className="footer-title">Senior Software Architect & Backend Specialist</h3>
            <p className="footer-description">
              Transforming complex challenges into elegant solutions through innovative technology and strategic architecture. 
              Let's build the future together.
            </p>
          </Col>
          <Col lg={4} md={6} className="footer-links">
            <h4 className="footer-links-title">Quick Links</h4>
            <ul className="footer-links-list">
              <li>
                <a 
                  href="#about" 
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('about');
                  }}
                >
                  About
                </a>
              </li>
              <li>
                <a 
                  href="#technical-skills" 
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('technical-skills');
                  }}
                >
                  Skills
                </a>
              </li>
              <li>
                <a 
                  href="#professional-experience" 
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('professional-experience');
                  }}
                >
                  Experience
                </a>
              </li>
              <li>
                <a 
                  href="#featured-projects" 
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('featured-projects');
                  }}
                >
                  Projects
                </a>
              </li>
              <li>
                <a href="mailto:hassanabrar202@gmail.com">
                  Contact
                </a>
              </li>
            </ul>
          </Col>
        </Row>

        {/* Middle Section */}
        <Row className="footer-middle">
          <Col lg={6} md={6} className="footer-social">
            <div className="social-icons">
              <a
                href="https://github.com/HassanAbrar202"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <AiOutlineGithub />
              </a>
              <a
                href="https://www.linkedin.com/in/hassan-abrar-86600419a/"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <AiOutlineLinkedin />
              </a>
              <a
                href="mailto:hassanabrar202@gmail.com"
                className="social-icon"
              >
                <AiOutlineMail />
              </a>
            </div>
          </Col>
          <Col lg={6} md={6} className="footer-back-to-top">
            <button 
              className="back-to-top-btn"
              onClick={scrollToTop}
            >
              <FaArrowUp />
              Back to Top
            </button>
          </Col>
        </Row>

        {/* Bottom Section */}
        <Row className="footer-bottom">
          <Col className="text-center">
            <p className="copyright">
              © 2025 Hassan Abrar. All rights reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
